import { HashedHotCardActionTypes, HashedHotCardState } from "./types";
import { fetchError, fetchRequest, fetchSuccess, saveRequest, saveSuccess, saveError } from "./actions";
import { createReducer } from "typesafe-actions";

export const initialState: HashedHotCardState = {
  loading: false,
  errors: undefined,
  data: []
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>;

export default createReducer<HashedHotCardState, ActionType>(initialState)
  .handleType(HashedHotCardActionTypes.FETCH, (state) => ({
    ...state,
    loading: true,
    data: [],
    errors: undefined,
  }))
  .handleType(HashedHotCardActionTypes.FETCH_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    data: action.payload.data ?? [],  // Ensure `data` is always an array
    errors: undefined,
  }))
  .handleType(HashedHotCardActionTypes.FETCH_ERROR, (state, action) => ({
    ...state,
    loading: false,
    data: [],
    errors: action.payload,
  }))
  .handleType(HashedHotCardActionTypes.SAVE_REQUEST, (state) => ({
    ...state,
    loading: true,
    errors: undefined,
  }))
  .handleType(HashedHotCardActionTypes.SAVE_SUCCESS, (state, action) => ({
    ...state,
    loading: false,
    //@ts-ignore
    data: action.payload.data,
    errors: undefined,
  }))
  .handleType(HashedHotCardActionTypes.SAVE_ERROR, (state, action) => ({
    ...state,
    loading: false,
    errors: action.payload,
    data: state.data,  // Retaining existing data on error
  }));
